// Constants for different requests for current reducer
export default {
  siteInfoCP: 'SITE_INFO_CP',
  updateSitePlanOrder: 'UPDATE_SITE_PLAN_ORDER',
};
